export default [{
    path: '/staff/test',
    name: 'staff',
    meta: {
        layout: 'main'
    },
    component: () => import('@/views/staff/test')
}];
